// extracted by mini-css-extract-plugin
export var button = "ef4fc";
export var disabled = "_34a69";
export var hover = "df225";
export var label = "_81319";
export var logo = "_7703c";